import { QueryClient } from '@tanstack/react-query';

// Module-level singleton so non-React modules (e.g. `api/interceptors.ts`,
// `shared/hooks/use-logout.ts`) can call `queryClient.clear()` on logout / 401
// without going through `useQueryClient()`. Same instance is handed to
// `<QueryClientProvider>` in `QueryProvider.tsx`.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
